import { createScopedDescriptor, set } from 'quartz-core-utils/globalState/api';
import { initAppTranslations } from 'I18n/init/setup/AppInit';
import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import BasicI18nSetup from 'I18n/init/setup/BasicI18nSetup';
import BasicPublicI18nSetup from 'I18n/init/setup/BasicPublicI18nSetup';
// This file only has 2 keys for our error message so we sync load all translations for it, so the global error is always available
import quartzCoreLang from 'i2l?sync&query=sporks!../../../../lang/en.lyaml';
import { Metrics } from '../../../internal/metrics';

// Similar to RegisterableIntlProvider, but with no options to register.

// Create a silo property to store the I18n provider
export const I18N_PROVIDER = createScopedDescriptor('i18nProvider', 'EXECUTION_CONTEXT');
export async function initializeI18n({
  lang,
  localeInfo,
  createPublicProvider,
  registerFn
}) {
  const i18nProvider = createPublicProvider ? createPublicI18nProvider({
    manuallySetLocale: !!localeInfo
  }) : createStandardI18nProvider();
  const langAvailable = initAppTranslations([lang && i18nProvider.register(lang), i18nProvider.register(quartzCoreLang), registerFn(i18nProvider)]);
  if (localeInfo) {
    i18nProvider.setLocale(localeInfo);
  } else if (!createPublicProvider) {
    // The public provider calculates locale internally if not overridden
    i18nProvider.setLocale({
      langEnabled: false
    });
  }

  // For back-compat with BasicI18nSetup
  BasicI18nSetup.provider = i18nProvider;
  BasicPublicI18nSetup.provider = i18nProvider;
  set(I18N_PROVIDER, {
    register: i18nProvider.register,
    setLocale: () => {
      Metrics.counter('i18n_setLocale_called').increment();
    }
  });
  await langAvailable;
}